/**
 * Define sell-micro-app ui errors to be displayed.
 */
export class SellErrorsLocal {
  static REVIVE_OFFER_LESS_OFFER_AMOUNT = 'Enter a revive amount greater than or equal to the buyer offer to proceed.';
  static REVIVE_OFFER_BUY_NOW_THRESHOLD = 'Enter an amount greater than or equal to the current amount and less than the Buy Now price to proceed.';
  static REVIVE_NOT_ON_BUYER_BIDLIST = 'You can’t revive this offer anymore because the vehicle is no longer on the buyer’s bid list.';
  static errorMap = new Map ([
    ['REVIVE_OFFER_LESS_OFFER_AMOUNT', SellErrorsLocal.REVIVE_OFFER_LESS_OFFER_AMOUNT],
    ['REVIVE_OFFER_BUY_NOW_THRESHOLD', SellErrorsLocal.REVIVE_OFFER_BUY_NOW_THRESHOLD],
    ['REVIVE_NOT_ON_BUYER_BIDLIST', SellErrorsLocal.REVIVE_NOT_ON_BUYER_BIDLIST]
  ]);

  static getErrorMessage(error) {
    return SellErrorsLocal.errorMap.get(error);
  }

}
